module.exports = "/packs/images/svg/alert-medium~bec520421debc96faedc38a87d5a7b40.svg";